export default __webpack_public_path__ + "static/media/faq-bubbles.dc861ca5.svg";